import React from "react";
import styled from 'styled-components';
import Libreria from "../assets/libreria.jpg"


const PreFrontHeader = styled.div`
  background-color: black;
  padding: 10px;
  padding-top: 45px;
  text-align: center;
  background-image: url(${Libreria});
  background-size: cover;
`;

export default ({children}) => {
  return <PreFrontHeader>
    <div>{children}</div>
  </PreFrontHeader>
}
